import {useContext} from "react";
import ProductForm from "../components/ProductForm.tsx";
import ProductContext from "../contexts/ProductContext.tsx";
import {useTranslation} from "react-i18next";
import {IProduct} from "../models/IProduct.ts";

const CreateProductPage = () => {
    const {createProductMutation, createProductError} = useContext(ProductContext)
    const {t} = useTranslation()
    const product: IProduct = {
        name: {
            en: '',
            de: '',
        },
        price: 0,
        description: {
            en: '',
            de: '',
        },
        materials: {
            en: '',
            de: '',
        },
        careInstructions: {
            en: '',
            de: '',
        },
        category: '',
        images: [],
        inStock: true,
        amount: 0,
        shippingCosts: [
            {region: 'DE', cost: 0},
            {region: 'EU', cost: 0},
            {region: 'INT', cost: 0}
        ]
    }
    return (
        <ProductForm productMutation={createProductMutation} mutateProductError={createProductError}
                     formData={product} submitText={t('CREATE_PRODUCT_BUTTON_TEXT')}
                     headlineText={t('CREATE_PRODUCT_TEXT')}/>
    )
}

export default CreateProductPage;